// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"28a8f8d0","511":"171c3ea7","673":"c8532160"}[chunkId] + ".chunk.js";
};